<app-navigation-header
	title="Add Device Note"
	[detail]="device.serialNumber"
	i18n-title="@@addDeviceNoteMainTab-addDeviceNoteTitle"
	svgName="sl-add"
>
	<div class="mat-stepper-navigator">
		@if (stepperRef.selectedIndex === 0) {
			<button
				mat-button
				(click)="movePrevious(stepperRef)"
				data-automation-id="add-device-note-back-button"
				class="secondary-stepper-button"
				i18n="@@addDeviceNoteMainTab-backButton"
			>
				Back
			</button>
		}
		@if (stepperRef.selectedIndex === 0) {
			<button
				mat-flat-button
				(click)="moveNext(stepperRef)"
				data-automation-id="add-device-note-continue-button"
				class="primary-stepper-button"
				i18n="@@addDeviceNoteMainTab-continueButton"
				[disabled]="!isValid()"
			>
				Continue
			</button>
		}
	</div>
	<mat-horizontal-stepper linear #stepperRef>
		<mat-step>
			<ng-template matStepLabel i18n="@@addDeviceNoteMainTab-1/Information">Add Note</ng-template>
			<app-add-device-note-details [appVisitNote]="appVisitNote" [deviceId]="deviceId"> </app-add-device-note-details>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@addDeviceNoteMainTab-2/Confirmation">Confirmation</ng-template>
			<app-add-device-note-confirmation
				[deviceId]="deviceId"
				[deviceSN]="device.serialNumber"
				[addAppVisitNoteStatusEvents]="addAppVisitNoteStatusEvents"
			>
			</app-add-device-note-confirmation>
		</mat-step>
	</mat-horizontal-stepper>
</app-navigation-header>
